import { useState, useEffect, useCallback } from "react";

const KEY = "ezi_favourites";

function load() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

// Persisted list of saved (favourited) domains.
export default function useFavourites() {
  const [favourites, setFavourites] = useState(load);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(favourites));
  }, [favourites]);

  const toggle = useCallback((domain) => {
    setFavourites((f) =>
      f.includes(domain) ? f.filter((d) => d !== domain) : [...f, domain]
    );
  }, []);

  const remove = useCallback((domain) => {
    setFavourites((f) => f.filter((d) => d !== domain));
  }, []);

  const clear = useCallback(() => setFavourites([]), []);

  return { favourites, toggle, remove, clear };
}
